import { adminApiFetch } from './apiService';

export const billingService = {
  fetchList: async () =>
    adminApiFetch('merchant_billings', { method: 'GET' }).then(r => r.json()),

  get: async (billingId) =>
    adminApiFetch(`merchant_billings/${billingId}`, { method: 'GET' }).then(r => r.json()),
};
